import { styled } from 'styled-components';
import { getFontSize, getFontWeight } from '../../../abstracts/typography';
import { dontForwardProps } from '../../../util';
export const TextareaInput = styled.textarea.withConfig(dontForwardProps()).withConfig({
  componentId: "aui__sc-1aps613-0"
})(["border:none;border-radius:0.5rem;box-sizing:border-box;display:block;font-size:", ";font-family:inherit;-webkit-appearance:none;-moz-osx-font-smoothing:grayscale;font-weight:", ";height:", ";outline:0;width:99%;padding:0.125rem 1.1875rem 0.9375rem 0.75rem;resize:", ";cursor:auto;background-color:transparent;color:var(--aui-on-surface);&:disabled{opacity:var(--aui-state-layer-on-disabled);}"], getFontSize(2), getFontWeight('base'), ({
  rows
}) => rows ? 'auto' : '8rem', ({
  resize
}) => resize ? 'vertical' : 'none');